import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";

const TOASTER_OPTIONS = {
  style: {
    background: "#081622",
    border: "1px solid rgba(255,122,0,0.4)",
    color: "#fff",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" toastOptions={TOASTER_OPTIONS} />
    </div>
  );
}

export default App;
